import { DropDownItem } from "views/pages/DataPage/CardsView/DataPageFilters/DropDownItem";
import { DropDownItem as DropDownItemType } from "types";
import styles from "./style.module.scss";
import classNames from "classnames";

interface DropDownProps {
  classname?: string;
  variant?: "light";
  showRadioButton?: boolean;
  items: DropDownItemType[];
  selectedItemsIds: string[];
  onItemSelection: (value: string) => void;
}

const DropDown: React.FC<DropDownProps> = ({
  items,
  variant,
  classname,
  selectedItemsIds,
  showRadioButton = true,
  onItemSelection,
}) => {
  const dropdownClassnames = classNames(styles.dropdown, classname);
  return (
    <div className={dropdownClassnames}>
      {items.map((item) => (
        <DropDownItem
          key={item.id}
          item={item}
          variant={variant}
          showRadioButton={showRadioButton}
          isSelected={selectedItemsIds.includes(item.id)}
          onSelect={onItemSelection}
        />
      ))}
    </div>
  );
};

export default DropDown;
